export default "__VITE_ASSET__2pgUXlHj__"